import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { MdArrowForward, MdDownload } from "react-icons/md";
import {
  HiOutlineAcademicCap,
  HiOutlineBookOpen,
  HiOutlineUserGroup,
  HiOutlineGlobeAlt,
} from "react-icons/hi";
import _ from "lodash";
import {
  phd,
  postgradute,
  PostgraduateDeploma,
} from "../../../data/programs";
import bupostgraduateProspectus from "./bupostgraduateprospectus.pdf";
import heroBanner from "../../../assets/images/academics/postgraduate/pg-hero-banner.jpg";

const backet =
  "https://bu-page-assets.s3.ap-northeast-1.amazonaws.com/static-assets";
const deanImg = backet + "/postgrad/fuje.jpg";

const PostgradHome = () => {
  const stats = useMemo(() => {
    const programTotal =
      postgradute.length + PostgraduateDeploma.length + phd.length;
    const faculties = _.uniq([
      ..._.map(postgradute, "school"),
      ..._.map(PostgraduateDeploma, "school"),
      ..._.map(phd, "school"),
    ]).length;

    return [
      {
        label: "Programs",
        value: `${programTotal}+`,
        Icon: HiOutlineBookOpen,
        tone: "#0863AA",
        soft: "rgba(8, 99, 170, 0.1)",
      },
      {
        label: "Faculties",
        value: `${faculties}+`,
        Icon: HiOutlineAcademicCap,
        tone: "#0d9488",
        soft: "rgba(13, 148, 136, 0.12)",
      },
      {
        label: "Professionals awarded",
        value: "1,000+",
        Icon: HiOutlineUserGroup,
        tone: "#0a3d6b",
        soft: "rgba(10, 61, 107, 0.1)",
      },
      {
        label: "Partner universities",
        value: "8+",
        Icon: HiOutlineGlobeAlt,
        tone: "#5eb3d4",
        soft: "rgba(94, 179, 212, 0.15)",
      },
    ];
  }, []);

  return (
    <div className="bg-[#f3f7fb]">
      <section className="relative min-h-[420px] overflow-hidden bg-[#0a2342] sm:min-h-[520px] xl:min-h-[600px]">
        <img
          src={heroBanner}
          alt="Benadir University Postgraduate Studies and Research"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a2342]/55 via-transparent to-transparent" />
        <div className="relative mx-auto flex min-h-[420px] max-w-6xl items-end px-4 pb-10 pt-24 sm:min-h-[520px] sm:px-6 sm:pb-12 xl:min-h-[600px]">
          <div className="pg-animate-in flex flex-wrap gap-3">
            <Link
              to="/academics/postgraduate/programs"
              className="inline-flex items-center gap-2 bg-[#0863AA] px-6 py-3 font-bold text-white transition hover:bg-[#0a4f86]"
            >
              Our Programs
              <MdArrowForward size={20} />
            </Link>
            <Link
              to="/academics/postgraduate/about"
              className="inline-flex items-center border-2 border-white bg-white/10 px-6 py-3 font-semibold text-white backdrop-blur-sm transition hover:bg-white hover:text-[#0a2342]"
            >
              About Us
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-white py-14">
        <div className="pg-dean mx-auto max-w-6xl px-4 sm:px-6">
          <div className="pg-dean-photo">
            <img
              src={deanImg}
              alt="Prof. Dr. Mohamed Mohamud Ali Fuje"
            />
            <div className="pg-dean-photo-meta">
              <p className="pg-dean-num">01</p>
              <div>
                <h2 className="pg-dean-name">
                  Prof. Dr. Mohamed Mohamud Ali Fuje
                </h2>
                <p className="pg-dean-role">
                  Dean, School of Postgraduate Studies
                </p>
              </div>
            </div>
          </div>
          <div className="pg-dean-copy">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#0863AA]">
              Dean&apos;s message
            </p>
            <h2 className="mt-3 text-3xl font-bold text-[#0a3d6b]">
              Welcome to the School of Postgraduate Studies
            </h2>
            <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-slate-700">
              <p>
                It is with great pleasure that I welcome you to the School of
                Postgraduate Studies of Benadir University. Since its beginning,
                the school has shown strong performance and reached important
                milestones. Our goal is quality education at an advanced level,
                and we intend to keep that standard.
              </p>
              <p>
                You can grow your knowledge through joint programmes with the
                International University of Africa in Sudan, Makerere
                University, and Istanbul Medeniyet University. We want graduates
                who have completed serious training and who are ready for
                professional work.
              </p>
              <p>
                I welcome you again and wish you success in your studies.
              </p>
            </div>
            <Link
              to="/academics/postgraduate/about"
              className="mt-6 inline-flex text-sm font-semibold text-[#0863AA]"
            >
              Admission, grading, and partnerships →
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-[#f3f7fb] py-14">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#0863AA]">
                At a glance
              </p>
              <h2 className="mt-2 text-3xl font-bold text-[#0a3d6b]">
                School of Postgraduate Studies in numbers
              </h2>
            </div>
            <Link
              to="/academics/postgraduate/programs"
              className="text-sm font-semibold text-slate-500 transition hover:text-[#0863AA]"
            >
              View all programmes →
            </Link>
          </div>

          <div className="pg-stats-grid">
            {stats.map(({ label, value, Icon, tone, soft }) => (
              <article key={label} className="pg-stat-card">
                <div
                  className="pg-stat-glow"
                  style={{ background: soft }}
                  aria-hidden
                />
                <div
                  className="pg-stat-icon"
                  style={{ background: tone }}
                >
                  <Icon size={22} color="#fff" />
                </div>
                <p className="pg-stat-value" style={{ color: tone }}>
                  {value}
                </p>
                <p className="pg-stat-label">{label}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#0863AA] py-12 text-white">
        <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 px-4 sm:flex-row sm:items-center sm:px-6">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#5eb3d4]">
              Prospectus 2025
            </p>
            <h2 className="mt-2 text-2xl font-bold">
              Download the School of Postgraduate Studies prospectus
            </h2>
          </div>
          <a
            href={bupostgraduateProspectus}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white px-6 py-3 font-bold text-[#0863AA] transition hover:bg-sky-50"
          >
            <MdDownload size={22} />
            Download PDF
          </a>
        </div>
      </section>
    </div>
  );
};

export default PostgradHome;
